import { Create, Form, Input, useForm, Row, Col, Switch, Select, useSelect } from '@pankod/refine-antd';
import { IResourceComponentsProps } from '@pankod/refine-core';
import { useState } from 'react';
import { ILabel } from 'types/label.interface';
import { IPackage } from 'types/package.interface';
import { IUser } from 'types/user.interface';

export const SubscriptionPackageCreate: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps, formLoading } = useForm<IPackage>();
    const [isShowListUser, setShowListUser] = useState<boolean>(false);

    const { selectProps: LabelSelectProps } = useSelect<ILabel>({
        resource: 'labels',
        fetchSize: 1000,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: UserSelectProps } = useSelect<IUser>({
        resource: 'users',
        fetchSize: 10000,
        optionLabel: 'email',
        optionValue: '_id',
        onSearch: (_value) => {
            return [];
        },
    });

    return (
        <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
            <Form {...formProps} layout='vertical'>
                <Row gutter={24}>
                    <Col
                        span={16}
                        xs={24}
                        sm={24}
                        md={16}
                        lg={16}
                    >
                        <Form.Item
                            label='Name'
                            name='name'
                            rules={[
                                {
                                    required: true,
                                    message: 'Name is required',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item
                            label='Is Active'
                            name='isActive'
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                        >
                            <Switch defaultChecked={true} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            label='Is Limit Access'
                            name='isLimitAccess'
                            rules={[
                                {
                                    required: false,
                                },
                            ]}
                        >
                            <Switch onClick={(value) => setShowListUser(value)} defaultChecked={false} />
                        </Form.Item>
                    </Col>
                    {isShowListUser && (
                        <Col span={16}>
                            <Form.Item
                                label='Only Users Can Access'
                                name='userAccess'
                                rules={[
                                    {
                                        required: false,
                                    },
                                ]}
                            >
                                <Select
                                    mode='multiple'
                                    {...UserSelectProps}
                                    filterOption={(input, option) => (option?.label as string)?.toLowerCase().includes(input.toLowerCase())}
                                />
                            </Form.Item>
                        </Col>
                    )}
                </Row>
                <Row gutter={24}>
                    <Col
                        span={8}
                        xs={24}
                        sm={24}
                        md={10}
                        lg={8}
                    >
                        <Form.Item
                            label='Days Recurring'
                            name='recurringDays'
                            rules={[
                                {
                                    required: true,
                                    message: 'Days Recurring is required',
                                },
                            ]}
                        >
                            <Input type='number' />
                        </Form.Item>
                    </Col>
                    <Col
                        span={8}
                        xs={24}
                        sm={24}
                        md={10}
                        lg={8}
                    >
                        <Form.Item
                            label='Max Downloads Per Month'
                            name='maxDownloadsPerMonth'
                            rules={[
                                {
                                    required: true,
                                    message: 'Max Downloads Per Month is required',
                                },
                            ]}
                        >
                            <Input type='number' />
                        </Form.Item>
                    </Col>
                    <Col
                        span={8}
                        xs={24}
                        sm={24}
                        md={10}
                        lg={8}
                    >
                        <Form.Item
                            label='Price ($)'
                            name='price'
                            rules={[
                                {
                                    required: true,
                                    message: 'Price is required',
                                },
                            ]}
                        >
                            <Input type='number' />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item
                            label='Labels Included'
                            name='labelsIncluded'
                            rules={[
                                {
                                    required: true,
                                    message: 'Labels Included is required',
                                },
                            ]}
                        >
                            <Select mode='multiple' {...LabelSelectProps} />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                >
                    <textarea
                        style={{
                            width: '100%',
                            color: '#626262',
                            border: '1px solid #d9d9d9',
                            padding: '4px 12px',
                            borderRadius: '6px',
                            fontSize: '14px',
                        }}
                    />
                </Form.Item>
            </Form>
        </Create>
    );
};
